import { faker } from '@faker-js/faker'

import { QuestionnaireType, SatisfactionStatistics } from '../../contracts/hospital'
import { asBuilder } from '../asBuilder'

const MIN_SHOW_COUNT = 30

const createSatisfactionStatisticsContents: () => SatisfactionStatistics['contents'] = () => {
  const questionnaireTypes = Object.values(QuestionnaireType)

  const contents: SatisfactionStatistics['contents'] = questionnaireTypes
    .map((type) => {
      const respondentCount = faker.number.int({ min: MIN_SHOW_COUNT, max: 1000000 })
      const satisfiedCount = faker.number.int({ min: 0, max: respondentCount })

      return {
        questionnaireType: type,
        respondentCount,
        satisfiedCount,
      }
    })
    .filter((content) => content.respondentCount > MIN_SHOW_COUNT || content.satisfiedCount > 0)

  return contents
}

export const getSatisfactionStatistics = asBuilder((): SatisfactionStatistics => {
  const totalRespondent = faker.number.int({ min: 0, max: 1000 })
  const totalRating = faker.number.float({ min: 0, max: 10, precision: 0.1 })
  const contents = totalRespondent < MIN_SHOW_COUNT ? [] : createSatisfactionStatisticsContents()

  return {
    totalRespondent,
    totalRating,
    contents,
  }
})
